module.exports = __webpack_public_path__ + "static/media/ProjectStep4.972c955a.png";